<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-sliders" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{ config.title }}</div>
            <div class="meta" v-if="config.enabled_at && config.disabled_at">
                {{activeDates}}
            </div>
            <div class="meta has-text-warning" v-if="!config.is_enabled">Disabled for Enrollment</div>
            <div class="meta has-text-info" v-if="config.is_hidden">Hidden from dropdown</div>

            <div class="meta"><strong>{{ config.price | currency }}</strong> <span class="has-text-grey ml-2" v-if="config.units">{{ config.units }} hours</span></div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="handle fas fa-bars" style="cursor: move"></i></span>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'CourseConfigTile',
        components: {CardListItem},
        props: {
            card: {
                required: true
            },
            config: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        },
        computed: {
            activeDates: function() {
                let s = moment(this.config.enabled_at);
                let e = moment(this.config.disabled_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMM D, YYYY, h:mm a - ') + e.format('h:mm a');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMM D, h:mm a - ') + e.format('MMM D, h:mm a, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D, h:mm a - ') + e.format('MMM D, h:mm a, YYYY');
                } else {
                    return s.format('MMM D, YYYY, h:mm a - ') + e.format('MMM D, YYYY, h:mm a');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: orangered;
        }
    }
</style>
